import React from "react";
import CompanyBlock from "./CompanyBlock";
import FacilityBlock from "./FacilityBlock";

const CarouselItem = ({ items, mode }: { items: any[]; mode: string }) => {
    return (
        <div className="row">
            {items.map((item, i) => (
                <div className="col-lg-4" key={i}>
                    {mode === "company" ? <CompanyBlock company={item} /> : <FacilityBlock facility={item} />}
                </div>
            ))}
        </div>
    );
};

export default CarouselItem;
